// extracted by mini-css-extract-plugin
export default {"defaultImg":"Profile_defaultImg__xCgr3","defaultDrop":"Profile_defaultDrop__tirkS"};